import { render, staticRenderFns } from "./WPEmptyList.vue?vue&type=template&id=7244983e"
import script from "./WPEmptyList.vue?vue&type=script&lang=ts"
export * from "./WPEmptyList.vue?vue&type=script&lang=ts"
import style0 from "./WPEmptyList.vue?vue&type=style&index=0&id=7244983e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports